import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { HighlightSelected } from '../../../HighlightSelected';

type WrapperProps = {
  featured: boolean;
  theme: any;
};

const Wrapper = styled(HighlightSelected)<WrapperProps>`
  border: 1px solid ${({ theme }) => theme.customColors.borderGreyLighter};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: ${({ featured }) => (featured ? '20px' : '22px 23px')};
  display: flex;
  flex-direction: column;

  ${media.md`
    display: flex;
    margin-bottom: 8px;
    padding: 22px 23px;
    flex-direction: row;
  `}
`;

export default Wrapper;
